// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logs-page {
  padding: 20px;
}
.logs-page .actions,
.logs-page .filters {
  margin-bottom: 20px;
}
.logs-page .table-row-error {
  background-color: #ff9b9b;
}
.logs-page .table-row-warning {
  background-color: #fff9b9;
}
`, "",{"version":3,"sources":["webpack://./src/app/main/data/dispute-invoices/logs/index.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAFA;;EAII,mBAAA;AAEJ;AANA;EAOI,yBAAA;AAEJ;AATA;EAUI,yBAAA;AAEJ","sourcesContent":[".logs-page {\n  padding: 20px;\n  .actions,\n  .filters {\n    margin-bottom: 20px;\n  }\n  .table-row-error {\n    background-color: #ff9b9b;\n  }\n  .table-row-warning {\n    background-color: #fff9b9;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
